import { z } from 'zod';

export const createRoomSchema = z.object({
  goal: z
    .string()
    .min(1, 'Focus goal is required')
    .max(200, 'Goal must be less than 200 characters'),
  projectId: z
    .string()
    .min(1, 'Please select a project'),
  roomCode: z
    .string()
    .min(1, 'Room code is required')
  ,
});

export type CreateRoomFormData = z.infer<typeof createRoomSchema>;
